/**
 * WPN GATEWAY ENTERPRISE WEB ADMIN API' dev
 *
 * API version: 1.0.0
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CoreApiClientService } from 'pn-core-code';

import { apiBaseUrl } from '../api-base-url';
import { FranchiseTierDropdownResponseDto } from '../model/franchiseTierDropdownResponseDto';
import { FranchiseTierPaginationResponseDto } from '../model/franchiseTierPaginationResponseDto';
import { FranchiseTierRequestDto } from '../model/franchiseTierRequestDto';
import { FranchiseTierResponseDto } from '../model/franchiseTierResponseDto';
import { FranchiseTierUpdateSequenceRequestDto } from '../model/franchiseTierUpdateSequenceRequestDto';
import { ValidationError } from '../model/validationError';

export enum franchiseTiersDropdownGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum franchiseTiersGetLanguageEnum {
  th = 'th',
  en = 'en',
}
export enum franchiseTiersIdGetLanguageEnum {
  th = 'th',
  en = 'en',
}

@Injectable({
  providedIn: 'root',
})
export class FranchiseTiersService {

  constructor(
    protected api: CoreApiClientService) {
  }

  /**
   * [Authorize] type: http
   */
  public franchiseTiersDropdownGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<Array<FranchiseTierDropdownResponseDto>> {
    return this.api.get(`${apiBaseUrl()}/franchise-tiers/dropdown`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersGet$(page?: number, limit?: number, name?: string, language?: string, isActive?: boolean, sort?: string): Observable<FranchiseTierPaginationResponseDto> {
    return this.api.get(`${apiBaseUrl()}/franchise-tiers`, { page, limit, name, language, isActive, sort });
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersIdDelete$(id: string): Observable<string> {
    return this.api.delete(`${apiBaseUrl()}/franchise-tiers/${encodeURIComponent(String(id))}`, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersIdGet$(id: string, language?: string): Observable<FranchiseTierResponseDto> {
    return this.api.get(`${apiBaseUrl()}/franchise-tiers/${encodeURIComponent(String(id))}`, { language });
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersIdPut$(id: string, body: FranchiseTierRequestDto): Observable<FranchiseTierResponseDto> {
    return this.api.put(`${apiBaseUrl()}/franchise-tiers/${encodeURIComponent(String(id))}`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersIdUpdateIsActivePatch$(id: string): Observable<string> {
    return this.api.patch(`${apiBaseUrl()}/franchise-tiers/${encodeURIComponent(String(id))}/update-is-active`, undefined, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersPost$(body: FranchiseTierRequestDto): Observable<FranchiseTierResponseDto> {
    return this.api.post(`${apiBaseUrl()}/franchise-tiers`, body, undefined);
  }
  /**
   * [Authorize] type: http
   */
  public franchiseTiersUpdateSequencePut$(body: Array<FranchiseTierUpdateSequenceRequestDto>): Observable<string> {
    return this.api.put(`${apiBaseUrl()}/franchise-tiers/update-sequence`, body, undefined);
  }
}
